export default __webpack_public_path__ + "static/media/fast.374d1cda.svg";